import clsx from 'clsx';
import { ForwardedRef, forwardRef } from 'react';
import { getJxtButtonClass, getJxtButtonTextClass } from '../JxtButton/styles';
import { ButtonSizeEnum, ButtonVariantEnum } from '../JxtButton/types';
import { AnchorVariantEnum, IJxtAnchor } from './types';

const variantMap: Record<AnchorVariantEnum, ButtonVariantEnum> = {
  [AnchorVariantEnum.Link]: ButtonVariantEnum.Link,
  [AnchorVariantEnum.LinkDark]: ButtonVariantEnum.LinkDark,
};

const JxtAnchor = (
  {
    variant = AnchorVariantEnum.Link,
    size = ButtonSizeEnum.Regular,
    href,
    newWindow = false,
    className = '',
    children,
  }: IJxtAnchor,
  ref: ForwardedRef<HTMLAnchorElement>
) => {
  const classes = getJxtButtonClass({ variant: variantMap[variant], size });

  return (
    <a
      href={href}
      target={newWindow ? '_blank' : undefined}
      rel={newWindow ? 'noopener noreferrer' : undefined}
      className={clsx(classes, className)}
      ref={ref}
    >
      <div className={getJxtButtonTextClass({ size })}>{children}</div>
    </a>
  );
};

export default forwardRef(JxtAnchor);

export * from './types';
